import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'

import { SaveValueInterface } from '../../../interfaces'
import { Complete } from '../../formParts'
import { CompleteSigned } from '../../formParts/completSigned'
import { SignatureSentinel } from '../../formParts/signatureSentinel'
import { SignatureResumeBanner } from '../../bannerResumeSignature'
import { OpenBankingStep } from '../../formParts/openBanking'

function SignatureForm() {
    const [claimObject, setClaimObject] = useState<any>({})
    const [groupsComplete, setGroupsComplete] = useState(0)
    const [activeGroup, setActiveGroup] = useState('signature')
    console.log('TEST..... CHECK')
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
    }

    const saveFieldValue = (dataToSave: SaveValueInterface) => {
        return { success: true, error: '' }
    }

    const activeGroupAssignment = async (group: string) => {
        // console.log('next group to display: ', group)
        // console.log('CLAIM OBEJECT : ', claimObject)
        setActiveGroup(group)
        window.scrollTo(0, 0)
        setGroupsComplete(groupsComplete + 2)
    }

    return (
        <>
            <div className={`${styles.formContainer} ${responsiveStyles.formContainer}`}>
                <form className={`${styles.form}`} onSubmit={(e) => handleSubmit(e)}>
                    <div className={styles.formFields}>
                        <SignatureSentinel
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />

                        <OpenBankingStep
                            isActive={activeGroup}
                            saveValueFunct={saveFieldValue}
                            assignGroup={activeGroupAssignment}
                        />
                        <Complete
                            isActive={activeGroup}
                            saveValueFunct={saveFieldValue}
                            assignGroup={activeGroupAssignment}
                        />
                    </div>
                </form>
            </div>
        </>
    )
}

export default SignatureForm
